import React, { useContext, useState, useRef, useEffect } from 'react';
import { GlobalContext } from '../../context/global-context';
import SettingsButtons from '../settings-buttons';
import Icon from '../icon';

const Settings: React.FC = () => {
  const { theme, setTheme } = useContext(GlobalContext);

  const [isChecked, setIsChecked] = useState(theme === 'light' ? false : true);

  const handleChange = () => {
    return setIsChecked(!isChecked);
  };

  useEffect(() => {
    const theme = localStorage.getItem('continia.theme');
    if (theme) {
      setIsChecked(theme === 'dark');
      setTheme(theme === 'dark' ? 'dark' : 'light');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('continia.theme', isChecked ? 'dark' : 'light');
    setTheme(isChecked ? 'dark' : 'light');
  }, [isChecked, setTheme]);

  return (
    <div className="flex justify-end align-center items-center ">
      <div className="h-20 flex justify-end align-center items-center mr-2">
        {/* <Icon name="sun" />
        <div className="flex mr-2 ml-2">
          <label className="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" className="sr-only peer" checked={isChecked} onChange={handleChange} />
            <div
              className={`w-11 h-6 rounded-full peer-checked:after:translate-x-full peer-checked:after:border-switchDot after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-switchDot after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-switchBackground ${
                isChecked ? 'bg-switchBackground' : 'bg-switchBackground'
              }`}
            ></div>
          </label>
        </div>
        <Icon name="clear-night" /> */}
      </div>
      <div>{/* <SettingsButtons /> */}</div>
    </div>
  );
};

export default Settings;
